module.exports = __webpack_public_path__ + "img/credit_card_24dp.540ea078.svg";